import { ImgHTMLAttributes, ReactElement, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { BookIcon } from './Icons';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  name: string;
  dimension: number | string;
}

export default function ImageIconWithFallback({
  name,
  dimension: dimensionIn,
  ...props
}: Props): ReactElement {
  const theme = useTheme();
  const { main: primaryMain } = theme.palette.primary;
  const { main: secondaryMain } = theme.palette.secondary;
  const [isFallback, setIsFallback] = useState(false);

  const dimension = Number(dimensionIn);

  const onError = () => {
    setIsFallback(true);
  };

  return (
    <>
      {isFallback ? (
        <Box
          aria-label={name}
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: primaryMain,
            color: secondaryMain,
            p: 2,
            width: 0.75 * dimension,
            height: dimension,
          }}
        >
          {dimension > 100 && <Typography variant="body1">{name}</Typography>}
          {dimension < 100 && (
            <BookIcon sx={{ color: secondaryMain }} fontSize={`${0.75 * dimension}px` as any} />
          )}
        </Box>
      ) : (
        <img
          {...props}
          src={props.src}
          aria-label={undefined}
          alt={props.alt || props['aria-label'] || name}
          style={{
            display: 'block',
            width: 0.75 * dimension,
            height: dimension,
            overflow: 'hidden',
            ...props.style,
          }}
          onError={onError}
        />
      )}
    </>
  );
}
